import React, { useEffect, useCallback, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { destinationColumns } from './DestinationData';
import DataTable from '../../../../../Common/DataTable/DataTable';
import DataTableHeader from '../../../../../Common/DataTableHeader/DataTableHeader';
import DataTableFooter from '../../../../../Common/DataTableFooter/DataTableFooter';
import { setCurrentPage } from '../../../../../Redux/slice/features/paginationSilce';
import { deleteDestination, fetchAllDestination, setSelectedDistrict } from '../../../../../Redux/slice/features/destinationSlice';
import EditDestination from './EditDestination';

const DestinationTable = () => {
    const dispatch = useDispatch();
    const { destinationData: allDestination,selectedDistrict,loading,error,status } = useSelector((state) => state.destination);
    const { currentPage, itemsPerPage } = useSelector((state) => state.pagination);
    const [editData, setEditData] = useState(null);
    const filteredData = useMemo(() => {return selectedDistrict? allDestination.filter((item) => item.district === selectedDistrict): allDestination;
    }, [allDestination, selectedDistrict]);

    const currentItems = useMemo(() => {
        const indexOfLastItem = currentPage * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;
        return filteredData.slice(indexOfFirstItem, indexOfLastItem);
    }, [filteredData, currentPage, itemsPerPage]);

    const totalPages = useMemo(() => 
        Math.ceil(filteredData?.length / itemsPerPage),
        [filteredData.length, itemsPerPage]
    );

    const handleNextPage = useCallback(() => {
        if (currentPage < totalPages) {
            dispatch(setCurrentPage(currentPage + 1));
        }
    }, [currentPage, totalPages, dispatch]);

    const handlePreviousPage = useCallback(() => {
        if (currentPage > 1) {
            dispatch(setCurrentPage(currentPage - 1));
        }
    }, [currentPage, dispatch]);

    const handleDelete = useCallback((id) => {
        if (window.confirm("Are you sure you want to delete this destination?")) {
            dispatch(deleteDestination(id))
                .unwrap()
                .then(() => dispatch(fetchAllDestination()))
                .catch((error) => {
                    console.error("Delete failed:", error);
                    alert(`Failed to delete destination: ${error.message}`);
                });
        }
    }, [dispatch]);

    const handleCloseModal = useCallback(() => {
        setEditData(null);
    }, []);
    const footerDataT = useMemo(() => ({
      length: filteredData.length
  }), [filteredData.length]);

    useEffect(() => {
        dispatch(fetchAllDestination());
    }, [dispatch]);

    useEffect(() => {
        dispatch(setCurrentPage(1));
    }, [itemsPerPage, dispatch]);

    const districtList = useMemo(() => 
        [...new Set(allDestination.map((item) => item.district))],
        [allDestination]
    );

    return (
        <>
            {status === "loading" && <h4>Loading...</h4>}
            {status === "failed" && <p>Error: {error}</p>}
            {status === "succeeded" && (
                <>
                    <div className="mb-2">
                        <label className="me-2">Filter by District:</label>
                        <select
                            onChange={(e) => dispatch(setSelectedDistrict(e.target.value))}
                            className="form-select"
                            value={selectedDistrict || ''}
                        >
                            <option value="">All Districts</option>
                            {districtList.map((district) => (
                                <option key={district} value={district}>
                                    {district}
                                </option>
                            ))}
                        </select>
                    </div>

                    <DataTableHeader 
                        columns={destinationColumns} 
                        data={filteredData} 
                    />
                    
                    <DataTable
                        columns={destinationColumns}
                        data={currentItems}
                        onDelete={handleDelete}
                        onEdit={setEditData}
                    />
                    
                    <DataTableFooter
                        dataT={footerDataT}
                        currentPage={currentPage}
                        itemsPerPage={itemsPerPage}
                        handleNextPage={handleNextPage}
                        handlePreviousPage={handlePreviousPage}/>
                    
                    <EditDestination 
                        editData={editData} 
                        onClose={handleCloseModal} 
                    />
                </>
            )}
        </>
    );
};

export default React.memo(DestinationTable);